import React from "react";
import { Box, Tab, Tabs as MaterialTabs } from "@mui/material";
import clsx from "clsx";

type TabOption<T extends string = string> = { label: string | React.ReactNode; value: T };
export type TabOptions<T extends string = string> = TabOption<T>[];

type TabsProps = {
  options: TabOptions;
  className?: string;
  ariaLabel?: string;
  tab: string;
  setTab: (tab: string) => void;
  onChange?: (newTab: string) => void;
  textColor: "primary" | "secondary" | "inherit";
};

export const Tabs = ({
  options,
  className,
  ariaLabel,
  tab,
  setTab,
  onChange,
  textColor,
}: TabsProps) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
      <MaterialTabs
        className={clsx("polaris_tabs", className)}
        value={tab}
        indicatorColor="primary"
        textColor={textColor || "primary"}
        onChange={(_, t: string) => {
          setTab(t);
          if (onChange) {
            onChange(t);
          }
        }}
        aria-label={ariaLabel}
        variant="scrollable"
        scrollButtons="auto"
      >
        {options.map((tabOption) => {
          return (
            <Tab
              className="polaris_tabs__tab"
              label={tabOption.label}
              value={tabOption.value}
              key={tabOption.value}
            />
          );
        })}
      </MaterialTabs>
    </Box>
  );
};

export const TabPanel = ({
  value,
  tab,
  children,
  className = "",
}: {
  value: string;
  tab: string;
  className?: string;
  children?: React.ReactNode;
}) => {
  if (value == tab) {
    return <div className={clsx(`tab-panel`, className)}>{children}</div>;
  }

  return null;
};
